import { Box, Icon, Text } from '@chakra-ui/react';
import { FaInfoCircle } from 'react-icons/fa';

import { useLEAccordionItemContext } from '../../../components/LEAccordion/LEAccordionItem/useLEAccordionItem';
import Popover from '../../../components/Popover';

const KeepMyCarTitle = () => {
  const { isExpanded } = useLEAccordionItemContext();

  return (
    <Box display="inline">
      <Text as="span" mr={2}>
        WHICH WOULD YOU LIKE TO DO?
      </Text>
      {isExpanded && (
        <Popover
          placement="auto"
          label={
            <Box fontWeight="normal">
              <Text fontWeight="bold">Buy It Out (Keep My Car)</Text>
              <Text mb={2}>
                Select this option if you want to get a loan to keep your leased vehicle.
              </Text>
              <Text fontWeight="bold">Sell or Turn In My Car</Text>
              <Text>
                Select this option if you want Lease End to help you sell your leased vehicle. Lease
                End CANNOT help you return your lease. If you want to return your lease, you’ll need
                to work directly with your dealership.
              </Text>
            </Box>
          }
          popoverBodyProps={{ textTransform: 'none', textAlign: 'left' }}
        >
          <span>
            <Icon as={FaInfoCircle} color="bostonBlue" boxSize="14px" mt={1} />
          </span>
        </Popover>
      )}
    </Box>
  );
};

export default KeepMyCarTitle;
